﻿import Toast from '../toast/index'

export default class ChangeChecker {
    constructor() {        
        this.toast = new Toast();
        this.count = $('.cart-items').innerHTML;
        this.init()
    }
    init() {
        

            if (localStorage.getItem('cart-count') === null || this.count === 0) {
                localStorage.setItem('cart-count', 0)
            }
            if (localStorage.getItem('cart-count') > this.count) {
                localStorage.setItem('cart-count', this.count)
            }
            else if (this.count > localStorage.getItem('cart-count')) {
                localStorage.removeItem('cart-count')
                const c = parseInt(this.count)
                localStorage.setItem('cart-count', c)
                this.toast.displayToast();

            }
    }
   
}